<div class="container">

<app-header-dialog [iconName]="'monetization_on'">
  Apoio
</app-header-dialog>

  <div class='content'>

    <form name="bannerForm" [formGroup]='bannerForm' autocomplete="off">

      <div *ngIf='isProduct'>
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Tipo</mat-label>
          <mat-select placeholder="Posição" [errorStateMatcher]="matcher" [formControl]="bannerForm.controls.type">
            <mat-option *ngFor="let type of typeList" [value]="type.id">
              {{ type.name }}
            </mat-option>
          </mat-select>

          <mat-error *ngIf="bannerForm.controls.type.hasError('required')">
            A posição é obrigatória
          </mat-error>
        </mat-form-field>
      </div>

      <div style='margin-top: 10px; text-align: center;'>
        <div class='img-input'>
          <input #file_banner type="file" accept='image/*' style='display:none' (change)="previewBannerImage($event)" />
        </div>
        <div class="post-image">
          <img [src]="storedBanner" *ngIf="storedBanner">
        </div>
        <div>
          <button mat-raised-button (click)='file_banner.click()'>
            <mat-icon class='icon-add'>image_search</mat-icon>
          </button>
        </div>
      </div>

      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Link</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="bannerForm.controls.link"
          autocomplete="off">
        <mat-error *ngIf="bannerForm.controls.link.hasError('required')">
          O link é obrigatório
        </mat-error>
      </mat-form-field>

    </form>

  </div>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>

    <button [disabled]='bannerForm.invalid' mat-raised-button
      (click)="matDialogRef.close([ bannerForm, objectBanner ])">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>

  </div>

</div>